import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REFRESH_TOKEN } from "../../../config/api";
import { storeAccessToken } from "../../../helper/manageAccessToken";

export const getNewToken = createAsyncThunk(
  "opportunities/getNewToken",
  async () => {
    try {
      const { data } = await Client({
        method: "POST",

        path: API_REFRESH_TOKEN,
        noRefreshToken: true,
      });
      const token = data?.data?.access_token;
      if (token) {
        storeAccessToken(data?.data?.access_token);
      }
      return data?.data?.access_token;
    } catch (error) {}
  }
);
